
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


export const ROLE_MODEL = {
    'name' : [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
    //'symbol' : [null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
  }